import { useEffect } from 'react';
import { useUser } from '@contexts/UserContext';
import { useAppDispatch, useAppSelector } from '@store';
import { fetchFolders, clearFolders } from '@store/slices/foldersSlice';

export const UserFoldersInitializer = () => {
  const { user } = useUser();
  const dispatch = useAppDispatch();
  const isLoadingFolders = useAppSelector((state) => state.folders.isLoading);
  const hasFetched = useAppSelector((state) => state.folders.hasFetched);

  useEffect(() => {
    const username = user?.username;

    // Clear folders when user logs out
    if (!username) {
      dispatch(clearFolders());
      return;
    }

    // Fetch folders when user is available and we haven't fetched yet
    if (!hasFetched && !isLoadingFolders) {
      dispatch(fetchFolders());
    }
  }, [user?.username, hasFetched, isLoadingFolders, dispatch]);

  return null;
};
